import { FlatLookupView } from "@/Common/Api/MedfarDictionaries/Dto/Responses/FlatLookupView";

class DocumentClassModel {
    public LookupCode: string;
    public LookupId: string;
    public _Name_EN: string;
    public _Name_FR: string;
    public _Name_ES: string;
    public Name: string;
    public NbDocuments: number;
    public IsSelected: boolean;
    public IsExpanded: boolean;
    public SubClasses: Immutable.Map<string, DocumentClassModel>;

    public static FromLookup(lookup: FlatLookupView): DocumentClassModel {
        return new DocumentClassModel({
            LookupCode: lookup.LookupCode,
            LookupId: lookup.LookupID,
            _Name_EN: lookup.en,
            _Name_FR: lookup.fr,
            _Name_ES: lookup.esMX,
            Name: lookup.GetValue(),
            NbDocuments: 0,
            SubClasses: Immutable.Map<string, DocumentClassModel>([]),
            IsSelected: false
        });
    }

    public constructor(fields?: Partial<DocumentClassModel>) {
        Object.assign(this, fields);
    }

    public Update(model?: DocumentClassModel): DocumentClassModel {
        if (!model)
            return;

        this.IsExpanded = model.IsExpanded;
        this.IsSelected = model.IsSelected;

        if (this.SubClasses?.count())
            this.SubClasses?.forEach(subClass => subClass.Update(model.SubClasses.get(subClass.LookupCode)));
    }

    public SetExpanded(IsExpanded: boolean): void {
        this.IsExpanded = IsExpanded;

        const subs = this.SubClasses
            .toArray()
            .map(s => {
                s.IsExpanded = IsExpanded;
                return s;
            });

        this.SubClasses = Immutable.Map<string, DocumentClassModel>(subs.map(item => [item.LookupCode, item]));
    }
}

export { DocumentClassModel };
